module.exports = __webpack_public_path__ + "static/media/captions_Irish_Shaw.c4678dc7.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Irish_Shaw.vtt
// module id = 119
// module chunks = 0